import { getValidAccessToken } from "../services/oauthservice";
import { encryptRSA } from '../services/encrypt.js';

// src/utils/apiLogger.js
export const createApiLog = async (requestData) => {
  try {
    const encrypted = await encryptRSA({ ...requestData });
     const token = await getValidAccessToken();
    const response = await fetch(
      `${process.env.REACT_APP_DIC_ADMIN_API}/v1/logs/api-logs`,
      {
        method: "POST",
        headers: {
             Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ encrypted }) 
      }
    );

    const data = await response.json();
    return data; // return success or error from API
  } catch (error) {
    console.error("Error creating API log:", error);
    return { success: false, message: error.message };
  }
};
